import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AiOutlineCaretDown } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { permission as usePermission } from 'store/auth/selector';
import sideMenuItems from './Menu';
import { useDispatch } from 'react-redux';
import { pushPage, pushPageSize } from 'store/state/stateSlice';

export const SideBar: React.FC = () => {
  const permission = useSelector(usePermission);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const hasPermission = (policy: string | undefined) => {
    return policy
      ? (permission || []).some((item: any) => item?.description === policy)
      : true;
  };

  const handlePageSizeChange = () => {
    dispatch(pushPage(1 as any));
    dispatch(pushPageSize(10 as any));
  };

  return (
    <div className='w-72 p-5 bg-gray-100 relative duration-300 md:block hidden min-h-[100vh]'>
      <div className='space-y-2 text-xs font-poppinsMedium tracking-wider'>
        {sideMenuItems.map(
          (item, key) =>
            hasPermission(item.policy) && (
              <div key={key}>
                {item.subMenu?.length ? (
                  <details className='group space-y-1'>
                    <summary
                      className={`px-3 py-3 mt-3 flex items-center gap-4 rounded-lg hover:bg-[#fef0ed] ${
                        location.pathname === item.to && 'bg-[#fef0ed]'
                      } cursor-pointer`}
                    >
                      {React.createElement(item.icon, { className: 'text-md' })}
                      <span>{item.name}</span>

                      <AiOutlineCaretDown className='ml-auto transition duration-300 group-open:-rotate-180' />
                    </summary>
                    <div className='pl-6 space-y-2'>
                      {item.subMenu.map(
                        (subItem, subKey) =>
                          hasPermission(subItem.policy) && (
                            <div
                              key={subKey}
                              className={`flex items-center gap-4 px-3 py-2 relative cursor-pointer ${
                                location.pathname === subItem.to
                                  ? 'h-11 bg-[#fef0ed] rounded-r-lg'
                                  : 'h-11 hover:bg-[#fef0ed]'
                              }`}
                              onClick={() => [
                                subItem.to && navigate(subItem.to),
                                handlePageSizeChange(),
                              ]}
                            >
                              {location.pathname === subItem.to && (
                                <div className='absolute left-0 w-1 h-11 bg-red-500 rounded-l-lg' />
                              )}

                              {subItem.icon &&
                                React.createElement(subItem.icon, {
                                  className: 'text-[12px]',
                                })}
                              <span>{subItem.title}</span>
                            </div>
                          )
                      )}
                    </div>
                  </details>
                ) : (
                  <div
                    className={`px-3 py-3 mt-3 flex items-center gap-4 relative ${
                      !item.to
                        ? 'cursor-not-allowed text-gray-400'
                        : 'cursor-pointer hover:bg-[#fef0ed]'
                    } ${
                      location.pathname === item.to
                        ? 'h-12 bg-[#fef0ed] rounded-r-lg'
                        : 'h-12'
                    }`}
                    onClick={() => [
                      item.to && navigate(item.to),
                      handlePageSizeChange(),
                    ]}
                  >
                    {location.pathname === item.to && (
                      <div className='absolute left-0 w-1 h-12 bg-red-500 rounded-l-lg' />
                    )}

                    {React.createElement(item.icon, {
                      className: 'text-[12px]',
                    })}
                    <span>{item.name}</span>
                  </div>
                )}
              </div>
            )
        )}
      </div>
    </div>
  );
};
